export default {
      id: "exclamation-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.8ad0c046.svg#exclamation",
      toString: function () {
        return this.url;
      }
    }